<crud-list class="col-12" [data]="table" detailUrl="/enaio-learn/admin/job-description/" restUrl="api/lrn/jobdescription">
</crud-list>
